import { Box, Typography } from '@mui/material';
import { TournamentStatus } from '@okletsplay/core';
import classNames from 'classnames';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { withTournamentStatus } from 'shared/HOC/withTournamentStatus';
import { BreakTimer } from 'modules/bracket/components/BreakTimer';
import { useStyles } from 'modules/tournaments/styles/TournamentAlert.styles';
import { useStyles as useEllipsisAnimationStyles } from 'shared/styles/EllipsisAnimation.styles';
import { useRoundBreakDelay } from 'modules/bracket/hooks/use-round-break-delay';

const TournamentBreakAlertComponent: FC = () => {
  const { classes: ellipsisAnimationClasses } = useEllipsisAnimationStyles();
  const { classes } = useStyles();
  const nextUserMatchGame = useSelector(currentTournamentSelector.nextUserMatchGame);

  const { gameBreakDuration } = useRoundBreakDelay(
    nextUserMatchGame?.roundId,
    nextUserMatchGame?.groupId
  );

  if (!nextUserMatchGame?.breakStartedAt) {
    return null;
  }

  return (
    <Box className={classes.root}>
      <Typography className={classNames(classes.title, classes.break)}>
        YOU ARE ON A BREAK
      </Typography>
      <BreakTimer
        prefix="Next Match in"
        startedAt={nextUserMatchGame?.breakStartedAt}
        duration={gameBreakDuration}
        completedState={
          <Typography
            className={classNames(classes.startingTimer, ellipsisAnimationClasses.loading)}
          >
            Next Match Starting
          </Typography>
        }
      />
    </Box>
  );
};

export const TournamentBreakAlert = withTournamentStatus(TournamentBreakAlertComponent, [
  TournamentStatus.Live,
]);
